import cn from 'classnames';
import { ReactNode } from 'react';
import { Link } from 'src/components/Link';
import { Logo } from 'src/components/Logo';
import { Wrapper } from 'src/components/Wrapper';

import s from './Header.module.scss';

function LogoDefault({ logoClassName = '' }: { logoClassName?: string }) {
  return (
    <Link
      href="/"
      data-qa="header_logo_link"
      className={s.logoWrapper}
      id={`promo-products-header`}
      analyticsOptions={{
        action: 'click',
        clickZone: 'header',
        clickElement: 'textclick',
        clickContent: 'logo',
        uniqueId: `promo-products-header`,
        transitionType: 'inside-link',
      }}
    >
      <Logo className={cn(s.logo, logoClassName)} />
    </Link>
  );
}

export function Header({
  className = '',
  wrapperClassName = '',
  logoClassName = '',
  contacts = true,
  children,
  telVariant = true,
}: {
  className?: string;
  children?: ReactNode;
  contacts?: boolean;
  wrapperClassName?: string;
  logoClassName?: string;
  telVariant?: boolean;
}) {
  return (
    <section className={cn(s.root, className)}>
      <Wrapper className={cn(s.wrapper, wrapperClassName)}>
        {children ?? <LogoDefault logoClassName={logoClassName} />}
        {contacts && (
          <section className={s.contacts}>
            <span className={s.title}>Отдел продаж</span>
            {telVariant ? (
              <a className={cn('link', s.phone)} href="tel:88005005103">
                8&nbsp;800&nbsp;500&nbsp;51&nbsp;03
              </a>
            ) : (
              <a className={cn('link', s.phone)} href="tel:+74952601264">
                +7&nbsp;495&nbsp;260&nbsp;12&nbsp;64
              </a>
            )}
          </section>
        )}
      </Wrapper>
    </section>
  );
}
